import { AppState, openLesson, goLobby } from '@/store/gameStore';
import { TUTORIAL_STEPS, isStepComplete, isTutorialComplete, progressPercent } from '@/progression/tutorial';
import { renderTileRow } from './tiles';
import { topbar } from './lobby';
import { parseTiles } from '@/engine/tiles';

// 각 단계에 곁들일 예시 패
const STEP_TILES: Record<string, number[]> = {
  tiles: parseTiles('1m5p9s東發中'),
  meld: parseTiles('234m'),
  tenpai: parseTiles('12p'),
  agari: parseTiles('789m'),
  riichi: parseTiles('5z'),
  score: parseTiles('123m'),
};

export function renderTutorial(state: AppState): HTMLElement {
  const root = document.createElement('div');
  root.appendChild(topbar(state));

  const screen = document.createElement('div');
  screen.className = 'screen';
  root.appendChild(screen);

  const back = document.createElement('button');
  back.className = 'btn btn--ghost';
  back.textContent = '← 로비';
  back.style.alignSelf = 'flex-start';
  back.onclick = goLobby;
  screen.appendChild(back);

  const h = document.createElement('h2');
  h.className = 'section-title';
  h.textContent = '마작 배우기';
  screen.appendChild(h);

  const pct = progressPercent(state.tutorial);
  const bar = document.createElement('div');
  bar.className = 'progress-bar';
  const fill = document.createElement('i');
  fill.style.width = `${pct}%`;
  bar.appendChild(fill);
  screen.appendChild(bar);

  const steps = document.createElement('div');
  steps.className = 'steps';
  TUTORIAL_STEPS.forEach((s, i) => {
    const done = isStepComplete(state.tutorial, s.id);
    const step = document.createElement('div');
    step.className = 'step';
    if (done) step.style.borderColor = 'var(--koke)';

    const no = document.createElement('div');
    no.className = 'step__no';
    no.textContent = String(i + 1);
    step.appendChild(no);

    const body = document.createElement('div');
    body.className = 'step__body';
    body.style.flex = '1';
    const title = document.createElement('h4');
    title.textContent = s.title;
    const goal = document.createElement('p');
    goal.textContent = s.goal;
    body.appendChild(title);
    body.appendChild(goal);
    if (STEP_TILES[s.id]) {
      const row = renderTileRow(STEP_TILES[s.id], { size: 'sm' });
      row.style.marginTop = '8px';
      body.appendChild(row);
    }
    step.appendChild(body);

    const act = document.createElement('button');
    act.className = done ? 'btn btn--ghost' : 'btn btn--primary';
    act.textContent = done ? '✓ 복습' : '해보기';
    act.onclick = () => openLesson(s.id);
    step.appendChild(act);

    steps.appendChild(step);
  });
  screen.appendChild(steps);

  if (isTutorialComplete(state.tutorial)) {
    const done = document.createElement('div');
    done.className = 'panel';
    done.style.cssText = 'padding:22px;text-align:center;margin-top:8px;';
    done.innerHTML = `
      <div style="font-family:var(--font-display);font-weight:700;font-size:22px;color:var(--kin)">튜토리얼 완료!</div>
      <p style="color:var(--text-dim);margin:8px 0 16px">시작 자금 30,000원을 받았어요. 이제 테이블에서 실전을 두어 보세요.</p>
    `;
    const go = document.createElement('button');
    go.className = 'btn btn--primary';
    go.textContent = '테이블로 가기';
    go.onclick = goLobby;
    done.appendChild(go);
    screen.appendChild(done);
  }

  return root;
}
